module.exports = __webpack_public_path__ + "static/support-9c029267309b9ddeec307ec6114009d2.png";